import React, { useEffect, useState } from "react";
import { getContainer } from "../../ioc/IOCSetup";
import { UserAttributeDefinition } from "../../http/protocol";
import { UserService } from "../../services/UserService";
import { UserAttributeService } from "../../services/UserAttributeService";
import { Form, FormListener } from "../form/Form";
import { FormGroup } from "../form/FormGroup";
import { FormInput } from "../form/FormInput";
import { SelectInput } from "../form/SelectInput";
import { Submit } from "../form/Submit";
import { UserActionContainerProps, UpdateActionStatus, UserActionContainer } from "./UserActionContainer";

export const UserAttributes: React.FC<UserActionContainerProps> = (props: UserActionContainerProps) => {

    const userService: UserService = getContainer().getUserService();
    const userAttributeService: UserAttributeService = getContainer().getUserAttributeService();

    const [error, setError] = useState("");
    const [userAttributeDefinitions, setUserAttributeDefinitions] = useState<UserAttributeDefinition[]>([]);
    const [selectedAttribute, setSelectedAttribute] = useState<UserAttributeDefinition | undefined>({});
    const [selectedAttributeOptions, setSelectedAttributeOptions] = useState<string[] | undefined>(undefined);
    const [form, setForm] = useState({ attributeId: "", inputValue: "" });

    function loadContent() {
        userAttributeService.list({}).then((response) => {
            setUserAttributeDefinitions(response.items || []);
        }).catch((error) => {
            setError(error.message);
        });
    }

    useEffect(() => {
        loadContent();
    }, []);


    function removeAttribute() {
        if (!selectedAttribute) return;
        if (!props.users) return;
        let users = [...props.users || []];
        for (let i = 0; i < users.length; i++) {
            try {
                let userAttributes = users[i].user!.attributes || {};
                delete userAttributes[selectedAttribute.attributeKey!];
                users[i].status = UpdateActionStatus.PENDING;
                users[i].description = `Prepared to  remove attribute "${selectedAttribute.attributeKey}" with value ${form.inputValue} `;
                users[i].request = () => new Promise<{ status: string; description: string; response: any; }>(async (resolve, reject) => {
                    userService.setAttributes(users[i].user.id!, userAttributes)
                        .then((response) => {
                            resolve({ status: UpdateActionStatus.OK, description: `Removed attribute "${selectedAttribute.attributeKey}"`, response: response });
                        })
                        .catch((error) => {
                            console.log("User test error", error);
                            resolve({ status: UpdateActionStatus.FAIL, description: `Failed  removing attribute "${selectedAttribute.attributeKey}"`, response: error });
                        });
                });
            } catch (error) {
                users[i].status = UpdateActionStatus.FAIL;
                users[i].description = `Failed  removing attribute "${selectedAttribute.attributeKey}"`;
            }
        }

        if (props.updateUsers) props.updateUsers(users);
    }

    function onChange() {
        setForm({ ...form, inputValue: "" });
    }

    const ref: FormListener<any> = {
        formDidUpdate: (formModel: any, validationMap: any) => {
            setForm(formModel);
            let newAttr = userAttributeDefinitions.find((attr: UserAttributeDefinition) => attr.id == formModel.attributeId);
            setSelectedAttribute(newAttr);
            if (newAttr && newAttr.options) {
                setSelectedAttributeOptions(newAttr.options.split(",").map((x: string) => x.trim()));
            } else {
                setSelectedAttributeOptions(undefined);
            }
        },
        onSubmit: () => {
            if (!selectedAttribute) return;
            if (!form.inputValue) return;
            if (!props.users) return;
            let users = [...props.users || []];
            for (let i = 0; i < users.length; i++) {
                try {
                    let userAttributes = users[i].user!.attributes || {};
                    userAttributes[selectedAttribute.attributeKey!] = form.inputValue;
                    users[i].status = UpdateActionStatus.PENDING;
                    users[i].description = `Prepared to add attribute "${selectedAttribute.attributeKey}" with value ${form.inputValue} `;
                    users[i].request = () => new Promise<{ status: string; description: string; response: any; }>(async (resolve, reject) => {
                        userService.setAttributes(users[i].user.id!, userAttributes)
                            .then((response) => {
                                resolve({ status: UpdateActionStatus.OK, description: `Added attribute "${selectedAttribute.attributeKey}" with value ${form.inputValue} `, response: response });
                            })
                            .catch((error) => {
                                console.log("User test error", error);
                                resolve({ status: UpdateActionStatus.FAIL, description: `Failed addding attribute "${selectedAttribute.attributeKey}"`, response: error });
                            });
                    });
                } catch (error) {
                    users[i].status = UpdateActionStatus.FAIL;
                    users[i].description = `Failed addding attribute "${selectedAttribute.attributeKey}"`;
                }
            }

            if (props.updateUsers) props.updateUsers(users);
        }
    };

    return (
        <UserActionContainer title={"User Attributes"} containerId={"user-attributes"} error={error}>
            <Form className="form-horizontal" formListener={ref} modelObject={form} validationMap={{}}>
                <FormGroup className="form-group row">
                    <div className="col-sm-8">
                        <SelectInput className="form-control" model="attributeId" onClick={(e: any) => onChange()}
                            optional={true} values={userAttributeDefinitions}
                            displayValue={(a) => { return a && a.attributeKey ? a.attributeKey.toString() : ""; }}
                            optionModelValue={(a: UserAttributeDefinition) => { return a.id; }} />
                    </div>
                    <div className="col-sm-4">
                        <Submit className="btn btn-danger"
                            onClick={(e) => { e.preventDefault(); removeAttribute(); }}>Remove
                        </Submit>
                    </div>
                </FormGroup>
                <FormGroup className="form-group row">
                    <div className="col-sm-8">
                        {!selectedAttributeOptions && (<FormInput className="form-control" type="text" model="inputValue" />)}
                        {selectedAttributeOptions && (
                            <SelectInput className="form-control" model="inputValue" optional={true} values={selectedAttributeOptions} />
                        )}
                    </div>
                    <div className="col-sm-4">
                        <Submit className="btn btn-primary">Add</Submit>
                    </div>
                    <span className={"help-block col"}>Choose a attribute to remove or add. Current selected label: {selectedAttribute && selectedAttribute.attributeKey}</span>
                </FormGroup>
            </Form>
        </UserActionContainer>
    );
};
